module.exports = __webpack_public_path__ + "img/weight-scale.0086b2ef.svg";